// extracted by mini-css-extract-plugin
export var blueGhost = "dmXNB7ia1ZJA0GiUzq1z fe7AoO_kLrhDq5G4toGx";
export var blueUnderlined = "fe7AoO_kLrhDq5G4toGx";
export var colourInherit = "a80X3Nb4u81_fbkosty0";
export var focusVisible = "FMbIGeReEDtxc0qMbYDD";
export var icon = "EEOFASfJ2rHRa6N9yqde";
export var root = "Mp9q7L0pR1gbUq4AMq1h";